import TagPage from './TagPage';
import TagPageContainer from './TagPage.container';

export default TagPageContainer(TagPage);
